import React, { useEffect, useRef, useState, memo, useCallback, useMemo } from "react";
import imagineHomeService from "./imagineHomeService";
import { Dropdown } from "primereact/dropdown";
import ListFiles from "./ListFiles";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import InvoiceDetails from "./InvoiceDetails";
import { ProgressBar } from "primereact/progressbar";
import QuotePreview from "../../components/QuotePreview";

const DesignerHome = ({ customerId, projectName, projectId, setShowProjDetails }) => {
    const serviceId = localStorage.getItem("serviceId");
    const [errMsg, setErrMsg] = useState("");
    const [selectedFileType, setSelectedFileType] = useState("");
    const [loader, setLoader] = useState(true);
    const room_file_type_master = useRef({});
    const [roomWiseFiles, setRoomWiseFiles] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [selectedTab, setSelectedTab] = useState("customer");
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [quotePreviewVisible, setQuotePreviewVisible] = useState(false);
    const [quotePreviewData, setQuotePreviewData] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);
    const [warningMessage, setWarningMessage] = useState([]);
    const [proposalErrorMessage, setProposalErrorMessage] = useState(false);
    const [showquoteApproval, setShowQuoteApproval] = useState(false);
    const [quotes, setQuotes] = useState({});
    const splitChar = "#";

    const fileUploadRef = useRef();
    const isDesignSelected = useMemo(() => selectedFileType.toLowerCase() === "design", [selectedFileType]);
    // const quotesMap = useRef({})
    // const invoiceMap = useRef({})
    const roomName = useRef("");
    const toast = useRef();

    const upload_down_map = {
        0: "customer",
        1: "designer",
    };

    const initData = () => {
        if (customerId !== "" && projectId !== "") {
            const formData = new FormData();

            formData.append("serviceId", serviceId);
            formData.append("customerID", customerId);
            formData.append("ProjectID", projectId);
            formData.append("isProjectActive", true);

            imagineHomeService.fetchProjectFilesNew(formData).then((res) => {
                if (res && res.file_records && res.file_records.length > 0) {
                    let roomWiseFilesResp = roomWiseFilterFiles(res.file_records);
                    setRoomWiseFiles(roomWiseFilesResp);
                    let proposals = buildDesignerFilesMapFromQuotes(res.quotes);
                    setQuotes(proposals);
                } else {
                    setRoomWiseFiles({});
                }
                setLoader(false);
            });
        }
    };
    useEffect(() => {
        initData();
    }, []);
    const roomWiseFilterFiles = (files) => {
        const customerFilesMap = {};
        const designerFilesMap = {};

        files.forEach((item) => {
            const room = item.roomName;
            const file = item.files?.fileName;
            const file_type = item.fileType;
            const room_type = item.roomType;
            const room_id = item.roomID;

            if (room) {
                const key = room_type + splitChar + room;
                const targetMap = item.usertype?.toLowerCase() === upload_down_map[0] ? customerFilesMap : item.usertype?.toLowerCase() === upload_down_map[1] ? designerFilesMap : null;

                if (targetMap) {
                    let details;

                    if (!targetMap[key]) targetMap[key] = {}; // ensure room object
                    if (!targetMap[key][file_type]) targetMap[key][file_type] = []; // ensure filetype array

                    targetMap[key][file_type].push({
                        projectName: item.ProjectName,
                        projectId: item.ProjectID,
                        filename: file,
                        room_id,
                        room,
                        roomType: room_type,
                        filekey: item.files?.location,
                        filetype: file_type,
                        details,
                        isQuote: false,
                    });
                }
            }
        });

        // Ensure designer map has all customer rooms (even if empty)
        for (let key in customerFilesMap) {
            if (!(key in designerFilesMap)) {
                designerFilesMap[key] = {
                    "": [
                        {
                            filename: "",
                            room: key.split(splitChar)[1],
                            roomType: key.split(splitChar)[0],
                            filekey: "",
                            filetype: "",
                        },
                    ],
                };
            }
        }
        let data = {
            [upload_down_map[0]]: customerFilesMap,
            [upload_down_map[1]]: designerFilesMap,
        };
        return data;
    };
    const buildDesignerFilesMapFromQuotes = (quotes) => {
        const designerFilesMap = {};
        quotes.forEach((quote) => {
            const item = quote.location; // location is the file path
            const splittedPath = item.split("/");
            const room = quote.roomName;
            const file = splittedPath[splittedPath.length - 1];
            const file_type = quote.fileType; // force file type to Quote
            const room_type = quote.roomType;
            const room_id = quote.roomID;

            const key = room_type + splitChar + room_id;
            if (!designerFilesMap[key]) designerFilesMap[key] = {};
            if (!designerFilesMap[key][file_type]) designerFilesMap[key][file_type] = [];
            designerFilesMap[key][file_type].push({
                projectName: quote.ProjectName,
                projectId: quote.ProjectID,
                filename: file,
                room,
                room_id,
                roomType: room_type,
                filekey: item,
                filetype: file_type,
                details: quote, // attach quote details
                isQuote: true,
            });
        });

        if (Object.keys(designerFilesMap).length === 0) {
            designerFilesMap[`_${splitChar}_`] = {
                Quote: [
                    {
                        projectId,
                        filename: "",
                        room: "_",
                        roomType: "_",
                        filekey: "",
                        filetype: "Quote",
                        details: null,
                        isQuote: true,
                    },
                ],
            };
        }

        return { ...designerFilesMap };
    };
    const handleUploadClick = (e, forQuote) => {
        if (forQuote) {
            setSelectedFileType("Quote");
        }
        let data = e.currentTarget.id;
        if (!room_file_type_master.current.roomType && !room_file_type_master.current.fileType) {
            room_file_type_master.current["fileType"] = [
                { name: "Design", value: "Design" },
                { name: "Files", value: "Files" },
            ];
            setShowModal(true);
        } else setShowModal(true);
        roomName.current = data;
    };

    const handleQuoteClicked = (data) => {
        setQuotePreviewData(data);
        setShowQuoteApproval(true);
    };
    const onFileSelect = (e) => {
        let filelist = files;
        if (e.files.length > 0) {
            if (isDesignSelected) {
                for (let i = 0; i < e.files.length; i++) {
                    filelist.push(e.files[i]);
                }
            } else filelist = [e.files[0]];
            setFiles(filelist);
        }
    };

    const handleUpload = () => {
        setUploadingFile(true);
        let validateres = validateSubmit();
        if (validateres) {
            setErrMsg(validateres);
            setUploadingFile(false);
            return;
        }
        setShowProgressBar(true);
        if (selectedFileType === "Quote") {
            const formData = new FormData();
            formData.append("serviceId", serviceId);
            formData.append("fileType", selectedFileType);
            formData.append("file", files[0]);
            imagineHomeService
                .uploadQuoteFile(formData)
                .then((res) => {
                    if (res) {
                        if (res.status === 200) {
                            setQuotePreviewData(res);
                            setShowProgressBar(false);
                            setUploadingFile(false);
                            hasErrors(res);
                            setQuotePreviewVisible(true);
                            toast.current.show({ severity: "success", summary: "Success", detail: "File Uploaded Successfully!" });
                        } else {
                            setShowProgressBar(false);
                            setUploadingFile(false);
                        }
                    } else {
                        setShowProgressBar(false);
                        setUploadingFile(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    toast.current.show({ severity: "error", summary: "Error", detail: "Error to add/update file" });
                    setShowProgressBar(false);
                    setUploadingFile(false);
                });
        } else {
            handleSubmit();
        }
    };
    const handleSubmit = () => {
        let rtype,
            rID = "";
        const formData = new FormData();
        rtype = roomName.current.split(splitChar)[0];
        rID = roomName.current.split(splitChar)[1];

        formData.append("fileType", selectedFileType);
        formData.append("serviceId", serviceId);
        formData.append("customerID", customerId);
        formData.append("ProjectID", projectId);
        formData.append("isCustomer", false);

        if (selectedFileType.toLowerCase() === "quote") {
            const selectionAllowed = taxConditions(quotePreviewData) === 3 ? 2 : 1;
            quotePreviewData.body["selectionAllowed"] = selectionAllowed;
            formData.append("docDetails", JSON.stringify(quotePreviewData.body));
        } else {
            formData.append("roomType", rtype);
            formData.append("roomID", rID);
        }

        imagineHomeService
            .saveRoomFiles(formData, files)
            .then((res) => {
                if (res && res.successRes > 0) {
                    if (res.successRes === files.length) toast.current.show({ severity: "success", summary: "Success", detail: "File Uploaded Successfully!" });
                    else toast.current.show({ severity: "warn", summary: "Partial Success", detail: "Partial File upload success" });
                    setSelectedFileType("");
                    setFiles([]);
                    setShowModal(false);
                    setQuotePreviewVisible(false);
                    if (selectedFileType === "Invoice") {
                        const tempObj = {
                            serviceId: serviceId,
                            customerID: customerId,
                            ProjectName: projectName,
                            roomType: rtype,
                            roomName: rID,
                            isCustomer: false,
                            fileType: "Invoice",
                            body: res.values[0]["body"],
                        };
                        setShowProjDetails(false);
                        setInvoiceDetails(tempObj);
                    }
                    initData();
                } else {
                    let msg = "Error to add/update file";
                    if (selectedFileType === "Invoice") msg = "Failed to extract invoice details.";
                    else msg = `${selectedFileType} upload failed`;
                    toast.current.show({ severity: "error", summary: "Error", detail: msg });
                }
                setUploadingFile(false);
                setShowProgressBar(false);
            })
            .catch((err) => {
                console.log(err);
                toast.current.show({ severity: "error", summary: "Error", detail: "Error to add/update file" });
                setUploadingFile(false);
                setShowProgressBar(false);
            });
    };
    const validateSubmit = () => {
        if (!selectedFileType) return "File Type Not Selected";
        if (!files.length) return "No File Chosen";
    };

    const changeTab = (e) => {
        if (e.target.tagName === "LI") {
            document.querySelectorAll("#tab li").forEach((li) => li.classList.remove("tab-selected"));
            e.target.classList.add("tab-selected");

            if (selectedTab === e.target.id) return;
            let newSelectedTab = "";
            Object.values(upload_down_map).forEach((item) => {
                if (item === e.target.id) {
                    newSelectedTab = item;
                }
            });
            setSelectedTab(newSelectedTab);
        }
    };

    const onBack = useCallback(() => {
        setInvoiceDetails([]);
        setShowProjDetails(true);
        setErrMsg("");
    }, []);

    const onApprovalClose = () => {
        setQuotePreviewData(null);
        setShowQuoteApproval(false);
    };

    const hasErrors = (data) => {
        setProposalErrorMessage(null);
        if (data.invalid_sku && data.invalid_sku.length) {
            // setProposalErrorMessage(data.invalid_sku[0].message);
        } else {
            showWarning(data);
        }
    };
    const isNoTax = (tax) => {
        if (tax == null) return true; // null or undefined

        if (typeof tax === "string") {
            const clean = tax.replace(/[^0-9.]/g, ""); // remove $ and other symbols
            return parseFloat(clean || "0") === 0;
        }

        if (typeof tax === "number") {
            return tax === 0;
        }

        return false;
    };

    // const showWarning = (data) => {
    //     setWarningMessage(null);
    //     let parts = [];

    //     // SKU check

    //     const missingSKUs = data.body.lineItems.filter((item) => !item.sku);
    //     if (missingSKUs.length) {
    //         parts.push("SKU number");
    //     }

    //     // Tax check
    //     const taxMsg = taxWarningMessage(data);
    //     if (taxMsg) {
    //         parts.push("Tax");
    //     }

    //     // Build merged warning
    //     if (parts.length) {
    //         let combined;

    //         if (parts.length === 1) {
    //             combined = `${parts[0]} is missing for some products`;
    //         } else {
    //             combined = `${parts.join(" & ")} are missing for some products`;
    //         }

    //         setWarningMessage(`${combined}`);
    //     }
    // };
    const showWarning = (data) => {
        setWarningMessage([]);
        // let messages = [];

        // // SKU check
        // const missingSKUs = data.body.lineItems.filter((item) => !item.sku);
        // if (missingSKUs.length) {
        //     messages.push("Some line items are missing SKUs. Please ensure that only Services (not Products like furniture or accessories) are without SKUs. Products require SKUs to identify the supplier.");
        // }
        // // Tax check
        // const taxMsg = taxWarningMessage(data);
        // if (taxMsg) {
        //     messages.push(taxMsg);
        // }
        // setWarningMessage(messages);
    };
    const taxConditions = (data) => {
        if (proposalErrorMessage) return;
        const missingTax = data.body.lineItems.filter((item) => !item.unitTax);

        if (!missingTax.length && !isNoTax(data.body.tax)) {
            return 1; // tax is defined for all
        }
        if (missingTax.length && isNoTax(data.body.tax)) {
            return 2; // tax is not defined for individual line items nor for all
        }
        if (missingTax.length && !isNoTax(data.body.tax)) {
            return 3; // tax is defined for all but not for individual line items
        }
        return 0;
    };
    // const taxWarningMessage = (data) => {
    //     switch (taxConditions(data)) {
    //         case 1:
    //             return undefined;
    //         case 2:
    //             return "Tax information is missing for all line items";
    //         case 3:
    //             return "To enable Line Item Approval for your clients, please add tax information for each line item in the proposal";
    //         default:
    //             return undefined;
    //     }
    // };
    if (Object.keys(invoiceDetails).length) return <InvoiceDetails receivedData={invoiceDetails} back={onBack} />;
    else
        return !loader ? (
            <div className="" style={{ color: "#1D1B1C" }}>
                <Toast ref={toast} />
                <div className="overflow-y-auto">
                    <ListFiles splitChar={splitChar} forQuote={true} data={quotes} upload={handleUploadClick} list="designer" quoteClicked={handleQuoteClicked} />
                </div>
                <div className="col-12 custom-tabview ">
                    <ul id="tab" onClick={changeTab}>
                        <li className="text-2xl tab-selected" id="customer">
                            Customer Scan
                        </li>
                        <li className="text-2xl" id="designer">
                            Designer Files
                        </li>
                    </ul>
                    <div className="overflow-y-auto">
                        <ListFiles splitChar={splitChar} data={roomWiseFiles[upload_down_map[selectedTab === "customer" ? 0 : 1]]} upload={handleUploadClick} list={selectedTab} quoteClicked={handleQuoteClicked} />
                    </div>
                </div>

                {showModal && (
                    <Dialog
                        showHeader={false}
                        visible={showModal}
                        modal
                        style={{ width: "40vw", color: "#1D1B1C", fontFamily: "Gerstner-ProgramRegular" }}
                        onHide={() => {
                            setShowModal(false);
                            setFiles([]);
                        }}
                        footer={
                            <div className="mx-3">
                                {proposalErrorMessage && <p className="text-lg font-semibold text-left mb-2 font-Gerstner-ProgramRegular">{proposalErrorMessage}</p>}

                                {warningMessage.length
                                    ? warningMessage.map((msg, i) => (
                                          <p key={i} className="text-lg font-semibold text-left mb-2 font-Gerstner-ProgramRegular">
                                              {msg}
                                          </p>
                                      ))
                                    : null}

                                <div className="flex justify-content-between">
                                    <div className="col-12 sm:col-6 md:col-3">
                                        <Button
                                            label="Cancel"
                                            className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                                            style={{ letterSpacing: "1.44px" }}
                                            onClick={(e) => {
                                                e.target.blur();
                                                setShowModal(false);
                                                setWarningMessage([]);
                                                setProposalErrorMessage(null);
                                                setQuotePreviewData(null);
                                                setSelectedFileType("");
                                                setQuotePreviewVisible(false);
                                                setFiles([]);
                                            }}
                                        />
                                    </div>
                                    <div className="col-12 sm:col-6 md:col-3">
                                        {quotePreviewVisible && warningMessage.length ? (
                                            <Button
                                                label={"OK"}
                                                className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                                                style={{
                                                    letterSpacing: "1.44px",
                                                    backgroundColor: "#BFAD5B",
                                                    borderColor: "#BFAD5B",
                                                }}
                                                onClick={(e) => {
                                                    e.target.blur();
                                                    setWarningMessage([]);
                                                }}
                                            />
                                        ) : (
                                            <Button
                                                disabled={uploadingFile}
                                                label={quotePreviewVisible ? "Proceed" : "Submit"}
                                                className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                                                style={{
                                                    letterSpacing: "1.44px",
                                                    backgroundColor: quotePreviewVisible && proposalErrorMessage ? "#BFAD5B" : "#9AAB89",
                                                    borderColor: quotePreviewVisible && proposalErrorMessage ? "#BFAD5B" : "#9AAB89",
                                                }}
                                                onClick={(e) => {
                                                    e.target.blur();
                                                    if (quotePreviewVisible) {
                                                        // if (proposalErrorMessage) {
                                                        //     setFiles([]);
                                                        //     setSelectedFileType("");
                                                        //     setQuotePreviewVisible(false);
                                                        //     setProposalErrorMessage(null);
                                                        // } else {
                                                        //     handleSubmit();
                                                        // }
                                                        handleSubmit();
                                                    } else {
                                                        handleUpload();
                                                    }
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        }
                    >
                        <div className="col-12 pt-3 charcoal">
                            {!quotePreviewVisible && (
                                <>
                                    <div className="col-12">
                                        <label>
                                            {selectedFileType.toLowerCase() !== "quote" ? "Select File Type" : "Upload Proposal"}
                                            {selectedFileType.toLowerCase() !== "quote" && (
                                                <Dropdown value={selectedFileType} options={room_file_type_master.current["fileType"] ?? []} onChange={(e) => setSelectedFileType(e.value)} className="bg-white w-full mt-1" optionLabel="name" placeholder="Select File Type" />
                                            )}
                                        </label>
                                    </div>

                                    <div className="col-12">
                                        <FileUpload
                                            name="demo[]"
                                            ref={fileUploadRef}
                                            customUpload={true}
                                            auto={true}
                                            multiple={isDesignSelected ? true : false}
                                            showUploadButton={false}
                                            onSelect={onFileSelect}
                                            onRemove={(e) => {
                                                let arr = files.filter((item) => item.name !== e?.file?.name);
                                                setFiles(arr);
                                            }}
                                            onClear={() => setFiles([])}
                                            mode="advanced"
                                        />
                                    </div>
                                    {errMsg && (
                                        <p className="text-center" style={{ color: "red" }}>
                                            {errMsg}
                                        </p>
                                    )}
                                    {showProgressBar && <ProgressBar mode="indeterminate" />}
                                </>
                            )}
                            {quotePreviewVisible && <QuotePreview quotePreviewData={quotePreviewData} />}
                        </div>
                    </Dialog>
                )}
                {showquoteApproval && (
                    <Dialog showHeader={false} visible={showquoteApproval} modal style={{ width: "50vw", color: "#1D1B1C", fontFamily: "Gerstner-ProgramRegular" }}>
                        <div className="col-12 pt-3 charcoal">
                            <QuotePreview quotePreviewData={quotePreviewData} type="approval" closeApproval={onApprovalClose} />
                        </div>
                    </Dialog>
                )}
            </div>
        ) : (
            <div style={{ width: "100%", textAlign: "center", height: "80vh", verticalAlign: "center", position: "relative" }}>
                <i className="pi pi-spin pi-spinner" style={{ fontSize: "4rem", verticalAlign: "middle", position: "absolute", top: "45%", left: "45%" }}></i>
            </div>
        );
};

export default memo(DesignerHome);
